import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { UserService } from "../services/user.service";

@Directive({
    selector: "[isSuperUser]",
})
export class IsSuperUserDirective {

    constructor(
        private userService: UserService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    @Input()
    set isSuperUser(_: boolean) {
        if (this.userService.isSuperUser) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}